import { inject } from '@angular/core';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';
import type { ManualChapter } from './manual.graphql';
import { ManualService } from './manual.service';

/**
 * Resource of the chapter named by `id()`, reloaded when the active language changes. Its value is
 * `null` when the backend refuses or does not know the chapter. Call it in an injection context.
 */
export function injectManualChapter(id: () => string | null) {
  const manual = inject(ManualService);
  const lang = toSignal(inject(TranslocoService).langChanges$);

  return rxResource<ManualChapter | null, { id: string; lang: string | undefined } | undefined>({
    params: () => {
      const chapterId = id();
      return chapterId ? { id: chapterId, lang: lang() } : undefined;
    },
    stream: ({ params }) => manual.chapter(params!.id),
    defaultValue: null,
  });
}
